(ns ncr.common.util
  (:require
   [clojure.core.match :refer [match]])
  (:require-macros
   [ncr.common.util :refer [error-m m-fail? m-result inline-resource]]))

(defn m-fail? [x]
  (match x [:error _] true _ false))

(defn m-result [tag x]
  (match x [tag v] v _ x))


